import { createRouter, createWebHistory } from 'vue-router'

export const DEFAULT_ROUTE = '/'

const router = createRouter({
  history: createWebHistory(),
  routes: [],
})

export default router
